var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FancyButton',_vm._g(_vm._b({staticClass:"btn",attrs:{"label":_vm.label,"width":"150","height":"48"}},'FancyButton',{ ..._vm.$attrs },false),{
        $listeners: _vm.$listeners,
        click: () => {
            _vm.handleClick();
        },
    }))
}
var staticRenderFns = []

export { render, staticRenderFns }